<template>
  <VueSlider
    v-model="_value"
    class="base-slider"
    :class="{ '-is-null': isValueNull }"
    :interval="+interval"
    :min="+min"
    :max="+max"
    :marks="true"
    tooltip="none"
    :duration="0"
    :dot-size="12"
    :disabled="disabled">
    <template #dot>
      <div
        class="base-slider__dot"
        @click="onClickDot" />
    </template>
    <template #label="{ label, active, value: markValue }">
      <div
        class="vue-slider-mark-label"
        :class="[{'vue-slider-mark-label-active': active}, { 'current-value': markValue === _value }]">
        {{ label }}
      </div>
    </template>
  </VueSlider>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  components: {
    VueSlider
  },
  props: {
    value: {
      type: Number,
      default: null
    },
    interval: {
      type: [String, Number],
      default: 1
    },
    min: {
      type: [String, Number],
      required: true,
    },
    max: {
      type: [String, Number],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        if (this.disabled) {
          return
        }
        return this.$emit('input', v) 
      }
    },
    isValueNull() {
      return this.value == null
    }
  },
  methods: {
    onClickDot() {
      this._value = null
    }
  }
}
</script>

<style lang="scss">
/** vue-slider-componentのpropsの方でもスタイリングできるが、うまくスタイリングできない箇所があったため、cssで全てスタイリングするようにした */
.base-slider {
  height: 2px !important;
  // labelに他の要素が被らないようにpaddingを設定
  padding: 8px 8px 28px !important;

  &__dot {
    width: 12px;
    height: 12px;
    background-color: $pink;
    border-radius: 50%;
    margin: 0 auto;
  }

  // 活性・非活性関係ないstyle
  .vue-slider {

    &-mark {
      width: 10px !important;
      height: 10px !important;
      border-radius: 50%;
      background-color: $white;
      &-step {
        display: none;
      }
    }

    &-rail {
      background-color: $white;
    }

    &-process {
      background-color: transparent;
    }

    &-mark {
      &-label {
        color: $grey05;
        margin-top: 4px !important;
        &.current-value {
          color: $pink;
        }
      }
    }
  }

  // nullの際はhandleを削除
    &.-is-null {
      .vue-slider {
        &-dot {
          display: none;
        }
      }
    }

  // 活性時のstyle
  &:not(.vue-slider-disabled) {
    .vue-slider {
      &-dot-handle {
        background-color: $pink;
      }
    }
  }

  // 非活性時のstyle
  &.vue-slider-disabled {
    &.vue-slider {
      opacity: 0.8;
    }
  }
}
</style>